import { PropsWithChildren } from "react";
import "./feedback-headline.less";

interface Props {
  className?: string
}

export default function FeedbackHeadline(props: PropsWithChildren<Props>) {
  let className = "feedback-headline";
  if (props.className) {
    className += " " + props.className;
  }

  return <div className={className}>
    {props.children}
  </div>
}